var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-breadcrumbs',{staticClass:"pa-0",attrs:{"items":_vm.items},scopedSlots:_vm._u([{key:"divider",fn:function(){return [_c('v-icon',[_vm._v("mdi-circle-small")])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }